export enum VirtualExpiryId {
  GoodForDay = 0,
  GoodTillCanceled = 1,
}
